import EventBase from './EventBase'
import EventID from './EventID'


export default class EventSimpleEffect extends EventBase {
  public constructor() {
    super()
    // 0：图片ID  1：类型  2：强度  3：是否循环 （0为false）  4：时间类型（0为帧）5：时间
    //Parameter = new string[6] { "3", "1", "50", "1", "0", "80" };
    this.Parameter = ['0', '0', '0', '0', '0', '0']
    //Parameter = new string[6] { "3", "0", "50", "1", "0", "80" };
  }

  /// <summary>
  /// 事件ID
  /// </summary>
  public Code = EventID.SimpleEffect

  // #region 事件内关键属性参数

  /// <summary>
  /// 图片ID
  /// </summary>
  get PicId() {
    return parseInt(this.Parameter?.[0] ?? '-1')
  }
  set PicId(value) {
    this.Parameter && (this.Parameter[0] = value.toString())
  }

  get EffectType() {
    return SimpleEffectType[parseInt(this.Parameter?.[1] ?? '')]
  }
  set EffectType(value) {
    this.Parameter && (this.Parameter[1] = value)
  }

  get Strength() {
    return parseInt(this.Parameter?.[2] ?? '-1')
  }
  set Strength(value) {
    this.Parameter && (this.Parameter[2] = value.toString())
  }

  get IsLoop() {
    return parseInt(this.Parameter?.[3] ?? '-1')
  }
  set IsLoop(value) {
    this.Parameter && (this.Parameter[3] = value.toString())
  }

  get IsSecond() {
    return parseInt(this.Parameter?.[4] ?? '-1')
  }
  set IsSecond(value) {
    this.Parameter && (this.Parameter[4] = value.toString())
  }

  get Duration() {
    return parseInt(this.Parameter?.[5] ?? '')
  }
  set Duration(value) {
    this.Parameter && (this.Parameter[5] = value.toString())
  }

  // #endregion 事件内关键属性参数

  get Description() {
    /*
                 简易特效：图片：3，马赛克：颗粒度：31，120帧
                 简易特效：图片：3，毛刺：程度：31，120帧，循环：是
                 简易特效：图片：3，放大淡出：百分比：90，120帧，循环：否
                 简易特效：图片：3，缩小后放大：百分比：90，120帧，循环：否
                 简易特效：图片：3，高斯模糊：颗粒度：31，120帧
                 */
    const sUnit = this.IsSecond === 0 ? ' 帧' : ' 秒'
    const duration = this.Duration
    const sLoop = this.IsLoop === 0 ? '否' : '是'
    let sRet = ''
    const effectNum = parseInt(this.Parameter?.[1] ?? '', 10)
    switch (effectNum) {
      case SimpleEffectType.None:
        sRet = `图片：${this.PicId}，无`
        break
      case SimpleEffectType.Mosaic:
        sRet = `图片：${this.PicId}，马赛克，颗粒度：${this.Strength}，${duration}${sUnit}`
        break
      case SimpleEffectType.Glitch:
        sRet = `图片：${this.PicId}，毛刺，程度：${this.Strength}，${duration}${sUnit}，循环：${sLoop}`
        break
      case SimpleEffectType.ZoomOutFade:
        sRet = `图片：${this.PicId}，放大淡出，百分比：${this.Strength}，${duration}${sUnit}，循环：${sLoop}`
        break
      case SimpleEffectType.ZoomInOut:
        sRet = `图片：${this.PicId}，缩小后放大，百分比：${this.Strength}，${duration}${sUnit}，循环：${sLoop}`
        break
      case SimpleEffectType.GaussianBlur:
        sRet = `图片：${this.PicId}，高斯模糊，颗粒度：${this.Strength}，${duration}${sUnit}`
        break
      default:
        break
    }

    return sRet
  }

  get DescriptionEasy() {
    let sRet = ''

    switch (this.PicId) {
      case 1:
        sRet = `远景图：${ this.GetEffectName() }`
        break
      case 2:
        sRet = `背景图：${ this.GetEffectName() }`
        break
      case 3:
        sRet = `左立绘：${ this.GetEffectName() }`
        break
      case 4:
        sRet = `右立绘：${ this.GetEffectName() }`
        break
      case 5:
        sRet = `中立绘：${ this.GetEffectName() }`
        break
      case 23:
        sRet = `前景图：${ this.GetEffectName() }`
        break
      default:
        break
    }

    return sRet
  }

  public GetEffectName() {
    let sRet = ''
    const effectNum = parseInt(this.Parameter?.[1] ?? '', 10)
    switch (effectNum) {
      case SimpleEffectType.None:
        sRet = '无'
        break
      case SimpleEffectType.Mosaic:
        sRet = '马赛克'
        break
      case SimpleEffectType.Glitch:
        sRet = '毛刺'
        break
      case SimpleEffectType.ZoomOutFade:
        sRet = '放大淡出'
        break
      case SimpleEffectType.ZoomInOut:
        sRet = '缩小后放大'
        break
      case SimpleEffectType.GaussianBlur:
        sRet = '高斯模糊'
        break
      default:
        break
    }

    return sRet
  }

}

enum SimpleEffectType {
  None = 0, // 无
  Mosaic = 1, // 马赛克
  Glitch = 2, // 毛刺
  ZoomOutFade = 3, // 放大淡出
  ZoomInOut = 4, // 缩小后放大
  GaussianBlur = 5, // 高斯模糊
}
